// extracted by mini-css-extract-plugin
export var details = "_dx-0";
export var inspectorPopover = "_dx-1";